/** First-run setup progress: Mode Of Study → School & Class → Study theme. */
export function SetupStepper({ step, total = 5, labels = ['Mode Of Study', 'School & Class', 'Study theme', 'Choose your plan', 'Your syllabus'] }) {
  if (!step) return null;
  return (
    <div className="flex items-center justify-center gap-2" data-testid="setup-stepper">
      <span className="text-[10px] font-heading uppercase tracking-widest text-indigo-600" data-testid="setup-step-label">
        Step {step} of {total}
      </span>
      <span className="flex items-center gap-1" aria-hidden="true">
        {Array.from({ length: total }, (_, i) => (
          <span key={i} title={labels[i] || ''}
            data-testid={`setup-step-dot-${i + 1}`}
            className={`h-1.5 rounded-full transition-all duration-300 ${i + 1 === step ? 'w-6 bg-indigo-600' : i + 1 < step ? 'w-3 bg-indigo-300' : 'w-3 bg-slate-200'}`} />
        ))}
      </span>
    </div>
  );
}

export default SetupStepper;
